import { createFileRoute } from "@tanstack/react-router";
import {
  CityDigitalMarketingPage,
  cityDigitalMarketingHead,
} from "@/components/CityDigitalMarketingPage";
import { industryLinksFor } from "@/lib/cityIndustryLinks";

export const Route = createFileRoute("/lone-tree-digital-marketing")({
  headers: () => ({
    "Cache-Control": "public, max-age=0, s-maxage=604800, stale-while-revalidate=2592000",
    "CDN-Cache-Control": "public, s-maxage=604800, stale-while-revalidate=2592000",
  }),
  head: () => cityDigitalMarketingHead("Lone Tree", "lone-tree"),
  component: () => (
    <CityDigitalMarketingPage
      city="Lone Tree"
      slug="lone-tree"
      intro="Lone Tree is one of the wealthiest, fastest-growing markets in metro Denver — and one of the highest-stakes for local service businesses. We help Lone Tree companies dominate Google, the Map Pack, and AI search from our Colorado Springs HQ just down I-25."
      whyUs={[
        "DTC corridor specialists — we know Lone Tree, RidgeGate, Heritage Hills, and the Park Meadows trade area",
        "Hyper-local SEO targeting the highest-income ZIP codes in Douglas County",
        "Owner-led strategy from Chris — not a Denver agency juggling 100 accounts",
      ]}
      nearby={[
        { name: "Highlands Ranch", to: "/highlands-ranch-digital-marketing" },
        { name: "Greenwood Village", to: "/greenwood-village-digital-marketing" },
        { name: "Centennial", to: "/centennial-seo" },
        { name: "Castle Rock", to: "/castle-rock-digital-marketing" },
        { name: "Parker", to: "/parker-digital-marketing" },
      ]}
      testimonial={{
        quote:
          "Chris built our site and SEO from the ground up. We've doubled the Lone Tree and Highlands Ranch lead flow in six months.",
        role: "Home Services Owner",
        city: "Lone Tree",
      }}
      industryLinks={industryLinksFor("Lone Tree")}
    />
  ),
});
